import achievements, { type AchievementKeys } from "~/data/achievements";

import { createNotification } from "~/js/notifications";

import select from "~/js/select";
import { addStat, getStatProgress } from "~/js/stats";
import { global, showPage } from "~/script";
import type { Achievement } from "~/types";
import { user } from "~/userStore";

let lastCheckTime = 0;

export function checkAchievements(): void {
	if (global.noSpoilers) return;
	if (lastCheckTime + 2000 > Date.now()) return;
	lastCheckTime = Date.now();
	for (const [achievementKey, achievement] of Object.entries(achievements) as [AchievementKeys, Achievement][]) {
		if (user.achievements[achievementKey] === true) continue;

		achievement.requirements.forEach((requirement) => {
			if ((getStatProgress(requirement) ?? 0) >= requirement.amount) {
				user.achievements[achievementKey] = true;
				addStat("achievements_completed", 1);
				createNotification({
					useHtml: true,
					message: `<div class="achievement-noti-title">Achievement Unlocked!</div><div class="achievement-noti-name">${achievement.name}</div><div class="achievement-noti-body">${achievement.description}</div>`,
					onclick() {
						showPage("achievements");
					},
				});
			}
		});
	}
	const uncollectedCount = Object.keys(user.achievements).length - Object.keys(user.achievements_collected).length;
	select("#achievements_not_collected")!.innerText = uncollectedCount > 0 ? uncollectedCount.toString() : "";
	select("#achievements_not_collected_b")!.innerText = uncollectedCount > 0 ? uncollectedCount.toString() : "";
}
